<div
  class="chat-via"
  [style.--via-sidebar-width]="sidebarWidth + 'px'"
  [class.open]="isChatViaOpen"
  [class.full-screen]="isFullScreen && isChatViaOpen"
>
  @if (isChatViaOpen) {
    <div class="chat-via__sidebar">
      <cpd-chat-sidebar
        [isExpanded]="isSidebarExpanded"
        [isAllConversations]="isShowAllConversations"
        [conversations]="conversations$ | async"
        [currentConversationId]="currentConversationId$ | async"
        [isFullScreen]="isFullScreen"
        [conversationsLoading]="conversationsLoading$ | async"
        [conversationsCount]="conversationsCount$ | async"
        [conversationsLimit]="conversationsLimit$ | async"
        [conversationsOffset]="conversationsOffset$ | async"
        (loadMore)="onLoadMore($event)"
        (toggleExpanded)="onToggleSidebar()"
        (newChat)="onNewChat()"
        (allConversations)="onAllConversations()"
        (conversationSelect)="onConversationSelect($event)"
      ></cpd-chat-sidebar>
    </div>
    <!-- Focusable so focus can wait here while an answer streams (A11Y.1). -->
    <div class="chat-via__content" tabindex="-1" role="region" aria-label="Via">
      <cpd-chat-header
        [isFullScreen]="isFullScreen"
        (toggleFullScreen)="onToggleFullScreen()"
        (closeChat)="onCloseChatVia()"
      ></cpd-chat-header>

      @if (isShowAllConversations) {
        <cpd-conversations
          [conversations]="conversations$ | async"
          [expanded]="isFullScreen"
          [conversationsLoading]="conversationsLoading$ | async"
          [conversationsCount]="conversationsCount$ | async"
          [conversationsLimit]="conversationsLimit$ | async"
          [conversationsOffset]="conversationsOffset$ | async"
          (loadMore)="onLoadMore($event)"
          (conversationSelect)="onConversationSelect($event)"
          (deleteConversation)="onDeleteConversation($event)"
          (back)="onBack()"
        ></cpd-conversations>
      } @else {
        <cpd-conversation
          [questionForm]="questionForm"
          [messages]="messages$ | async"
          [isLoading]="isLoading$ | async"
          [isStreaming]="isStreaming$ | async"
          [isFullScreen]="isFullScreen"
          [streamingResponse]="streamingResponse$ | async"
          [rateLimit]="rateLimit$ | async"
          [error]="error$ | async"
          (sendMessage)="onSendMessage($event)"
        ></cpd-conversation>
      }
    </div>
  }
</div>
